module.exports = __webpack_public_path__ + "img/MADDEN23-banner_day4.aee8d841.png";